import { memo, useState, useEffect } from 'react'
import { Template } from './Template'
import type { KcProps } from 'keycloakify'
import type { KcContext } from '../kcContext'
import { useKcMessage } from 'keycloakify/lib/i18n/useKcMessage'
import { useCssAndCx } from 'tss-react'
import { Button, Input, Form } from '@xanadu_ai/xanadu-component-library'

type KcContext_LoginResetPassword = Extract<
  KcContext,
  { pageId: 'login-reset-password.ftl' }
>

export const LoginResetPassword = memo(
  ({
    kcContext,
    ...props
  }: { kcContext: KcContext_LoginResetPassword } & KcProps) => {
    const { url, auth } = kcContext

    const { msg, msgStr } = useKcMessage()

    const { cx } = useCssAndCx()

    const [userEmail, updateUserEmail] = useState('')

    useEffect(() => {
      if (auth !== undefined && auth.showUsername && auth.attemptedUsername)
        updateUserEmail(auth.attemptedUsername)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
      <Template
        {...{ kcContext, ...props }}
        doFetchDefaultThemeResources={false}
        displayMessage={false}
        headerNode={msg('emailForgotTitle')}
        headerDescription="Join a community of learners, researchers, and developers to build the next generation of quantum technology."
        formNode={
          <Form
            formName="kc-reset-password-form"
            action={url.loginAction}
            method="post"
            onSubmit={(_e: React.SyntheticEvent) => {}}
          >
            <>
              <div className={cx(props.kcFormGroupClass)}>
                <div className={cx(props.kcInputWrapperClass)}>
                  <Input
                    formName="kc-reset-password-form"
                    testId="username"
                    type="text"
                    fieldName="username"
                    className={cx(props.kcInputClass)}
                    fieldLabel="Email"
                    value={userEmail}
                    onChange={(value: string) => updateUserEmail(value)}
                  />
                </div>
              </div>
              <div
                className={cx(props.kcFormGroupClass, props.kcFormSettingClass)}
              >
                <div className="w-full">
                  <div
                    id="kc-form-options"
                    className={cx(props.kcFormOptionsClass)}
                  >
                    <div className={cx(props.kcFormOptionsWrapperClass)}>
                      <span>
                        <a
                          href={url.loginUrl}
                          id="back-to-login"
                          data-testid="back-to-login"
                        >
                          {msg('backToLogin')}
                        </a>
                      </span>
                    </div>
                  </div>

                  <div
                    id="kc-form-buttons"
                    className={cx(props.kcFormButtonsClass)}
                  >
                    <Button
                      testId="submit-button"
                      className="justify-center"
                      buttonType="submit"
                      label={msgStr('doSubmit')}
                      disabled={!userEmail}
                    />
                  </div>
                </div>
              </div>
            </>
          </Form>
        }
        infoNode={msg('emailInstruction')}
      />
    )
  }
)
